import { getImageImage } from 'utils';

export const getBackgroundImage = (
  watchAppBackgroundImage,
  watchWebappBackgroundImage,
  isNormal,
  isApp,
) => {
  if (isNormal) {
    const backgroundImage = watchAppBackgroundImage || watchWebappBackgroundImage;
    return getImageImage(backgroundImage);
  };
  if (isApp) {
    return getImageImage(watchAppBackgroundImage);
  };
  return getImageImage(watchWebappBackgroundImage);
};
